<template>
  <div>
    <el-button type="primary" @click="openDialog()">新增用户</el-button>
    <el-button type="danger">清除用户身份票据</el-button>
    <el-table border :data="tableData" v-loading="loading" style="width: 100%">
      <el-table-column prop="id" label="序号"></el-table-column>
      <el-table-column prop="username" label="用户名"></el-table-column>
      <el-table-column prop="password" label="密码"></el-table-column>
      <el-table-column prop="active" label="是否启用">
        <template slot-scope="scope">{{ scope.row.active ? '是' : '否' }}</template>
      </el-table-column>
      <el-table-column prop="createdAt" label="创建时间" :formatter="dateFormat"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
              type="primary"
              icon="el-icon-edit"
              @click="handleEdit(scope.$index, scope.row)"
              :disabled="scope.row.username == 'admin'"
          ></el-button>
          <el-button
              type="danger"
              icon="el-icon-delete"
              @click="handleDelete(scope.$index, scope.row)"
              :disabled="scope.row.username == 'admin'"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        background
        layout="sizes, prev, pager, next"
        :page-sizes="[5, 10, 15, 20]"
        :total="total"
        :current-page="page"
        :page-size="size"
        @current-change="currentChange"
        @size-change="sizeChange"
    ></el-pagination>
    <el-dialog title="用户信息操作" :visible.sync="dialogFormVisible">
      <el-form :model="formData">
        <el-form-item label="登录名" :label-width="formLabelWidth">
          <el-input v-model="formData.username" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="密码" :label-width="formLabelWidth">
          <el-input v-model="formData.password" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="是否启用" :label-width="formLabelWidth">
          <el-radio v-model="formData.active" :label="true" border>是</el-radio>
          <el-radio v-model="formData.active" :label="false" border>否</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleCreateOrModify()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      dialogFormVisible: false,
      formLabelWidth: "120px",
      page: 1,
      size: 10,
      tableData: [],
      total: 0,
      formData: {
        id: 0,
        username: "",
        password: "",
        active: true,
        time: new Date()
      },
      options: {}
    };
  },
  mounted() {
    let token = "Bearer " + sessionStorage.getItem("token");
    this.options = {headers: {Authorization: token}};
    this.loadData();
  },
  methods: {
    loadData() {
      this.loading = true;
      this.$http.get(`user/list?page=${this.page}&size=${this.size}`, this.options).then(response => {
        this.tableData = response.data.list
        this.total = response.data.total
        this.loading = false;
      }).catch(e => {
        this.$message({
          message: e.message,
          type: "error"
        })
      })
    },
    openDialog() {
      this.formData.id = 0;
      this.formData.username = "";
      this.formData.password = "";
      this.formData.active = true;
      this.formData.time = new Date();

      this.dialogFormVisible = true;
    },
    handleCreateOrModify() {
      this.loading = true;
      this.$http.post("user/edit", this.formData, this.options).then(() => {
        this.loading = false;
        this.$message({
          message: "编辑成功！",
          type: "success"
        });
        this.dialogFormVisible = false;
        this.loadData();
      }).catch(e => {
        this.$message({
          message: e.message,
          type: "error"
        })
      })
    },
    handleEdit(index, row) {
      window.console.log(index, row);
      this.formData = row;
      this.dialogFormVisible = true;
    },
    handleDelete(index, row) {
      window.console.log(index, row);
      this.$confirm("此操作将永久此条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.loading = true;
        this.$http.post(`user/delete?username=${row.username}`, null, this.options).then(() => {
          this.loading = false;
          this.$message({
            message: "删除成功！",
            type: "success"
          });
          this.loadData();
        }).catch(e => {
          this.$message({
            message: e.message,
            type: "error"
          });
        });
      }).catch(() => {
        this.$message({
          type: "info",
          message: "已取消删除"
        })
      })
    },
    currentChange(val) {
      this.page = val
      this.loadData()
    },
    sizeChange(val) {
      this.size = val
      this.loadData()
    },
    dateFormat: function (row) {
      let t = new Date(row.createdAt);
      return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate();
    }
  }
};
</script>

<style scoped>
.el-table {
  margin-top: 20px;
}
</style>